import CurrencyTypes from 'store/actionTypes/currency'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {}
}

const currency = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case CurrencyTypes.GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case CurrencyTypes.GET_SYSTEM_CURRENCIES_SUCCESS:
      return { ...state, systems: payload?.currencies?.items }
    case CurrencyTypes.GET_CURRENCY_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case CurrencyTypes.UPDATE_FILTER_CURRENCY_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default currency
